import { company } from './company';

/**
 * Brand display values derived from the single company source of truth.
 * Do not hard-code company identity here — edit `config/company.ts` instead.
 */
export const brand = {
  name: company.brandName,
  company: company.legalName,
  domain: company.domain,
  email: company.publicEmail,
  phone: company.publicPhone,
  logo: '/images/esanza/logo.png',
  icon: '/images/esanza/icon.png',
};

/**
 * Preferred contact settings key, with a documented fallback to the legacy
 * `rwanda_phone` key used by older production data. Order:
 *   settings.contact_phone ?? settings.rwanda_phone ?? company.publicPhone
 */
export const resolveContactPhone = (
  settings: Record<string, unknown> | null | undefined,
): string => {
  const value = settings?.contact_phone ?? settings?.rwanda_phone;
  const text = value == null ? '' : String(value).trim();
  return text.length > 0 ? text : company.publicPhone;
};

export const featureFlags = {
  marketplaceVisible: true,
};

const adminBaseUrl = (process.env.REACT_APP_ADMIN_URL || 'https://admin.esanza.com')
  .replace(/\/+$/, '')
  .replace(/\/login$/i, '');

export const dashboardLoginUrl = `${adminBaseUrl}/login`;

export const images = {
  app: '/images/esanza/app-layout.jpeg',
  traceability: '/images/esanza/traceability.jpeg',
  traceabilityPhoto: '/images/esanza/tracebility.jpeg',
  tree: '/images/esanza/tree-tracking.jpeg',
};
